module.exports = __webpack_public_path__ + "img/7_78.2f187745.png";